import { Component, inject } from "@angular/core";
import { DrawerModule } from "primeng/drawer";
import { SelectAlertTypeComponent } from "../../components/select-alert-type/select-alert-type.component";
import { AlertsService } from "../../services/alerts.service";
import { ButtonOutlinedComponent } from "../../../../shared/components/button-outlined/button-outlined.component";
import { AlertType } from "../../utils/alert.enum";

@Component({
  selector: "twx-alert-type-mobile-selection",
  imports: [DrawerModule, SelectAlertTypeComponent, ButtonOutlinedComponent],
  templateUrl: "./alert-type-mobile-selection.component.html",
  styleUrl: "./alert-type-mobile-selection.component.scss",
})
export class AlertTypeMobileSelectionComponent {
  visible = true;

  readonly alerts = inject(AlertsService);

  onHide() {
    this.visible = false;
  }

  navigateToAlertMobileCreationFlow(alertType: AlertType) {
    this.alerts.navigateToMobileAlertCreationFlow(alertType);
    this.onHide();
  }
}
